import { Box } from "@mui/material";
import { TaskStateEnum } from "../../../AnnualWheel.types";
import AnnualWheelActivityStatusChip from "../../../annualWheelActivityStatusChip/AnnualWheelActivityStatusChip";
import { useTranslation } from "../../../../localization/useTranslation";
import { setFirstLetterToLowerCase } from "../../../../common/stringOperations";

interface StatusTimelineBarProps {
    status: TaskStateEnum;
    onClick?: () => void;
}

function StatusTimelineBar({ status, onClick }: StatusTimelineBarProps) {
    const { translateString } = useTranslation();

    const handleClick = onClick
        ? (e: React.MouseEvent) => {
              e.stopPropagation();
              onClick();
          }
        : undefined;

    const label = translateString(setFirstLetterToLowerCase(TaskStateEnum[status].toString()));

    return (
        <Box onClick={handleClick} sx={{ cursor: onClick ? "pointer" : undefined }}>
            <AnnualWheelActivityStatusChip status={status} value={label} />
        </Box>
    );
}

export default StatusTimelineBar;
